import noresults from '../../assets/noresults.svg';
import searchImg from '../../assets/search.svg';
import { TableContext } from '../../contexts/tableContext';
import { getCookies } from '../../hooks/useCookies';
import {
  REACT_APP_API_FETCH_BOOKED_USERS,
  SERVER_BASE_URL,
  SERVER_URL_WEB,
} from '../../redux/apiConstants';
import { Entry } from '../../redux/entrySlice';
import { CapitalizeFirstLetter, DateFormatter } from '../../utilityFunctions/utilsFunctions';
import CancelTicket from '../CancelTicket/CancelTicket';
import ConfirmAlertPopup from '../ConfirmAlertPopup/ConfirmAlert';
import InstructionsModal from '../InstructionsModal/InstructionsModal';
import Paginations from '../Pagination/AttendeePagination';
import PaymentSettingsModal from '../PaymentSettingsModal/PaymentSettingsModal';
import VerifyModal from '../VerifyModal/VerifyModal';
import styles from './AttendeeCustomTable.module.scss';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Image, Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';

const AttendeeCustomTable = React.memo(({ section = 'shows' }) => {
  let url;
  const {
    register,
    handleSubmit,
    reset,
    control,
    // formState: { errors },
  } = useForm();
  const { dashboardStyle, setDashboardHeader } = useContext(TableContext);
  const navigate = useNavigate();
  const params = useParams();
  const { bodyStyle } = useContext(TableContext);
  const [addButtonPermissions, setAddButtonPermissions] = useState({});
  const { searchboxStyle } = useContext(TableContext);
  const { tableheadStyle } = useContext(TableContext);
  const [tableData, setTableData] = useState([]);
  const [eventData, setEventData] = useState();
  const dispatch = useDispatch();
  const { pageNumView, setPageNumView } = useContext(TableContext);
  const [pageNum, setPageNum] = useState(1);
  // new
  const tablelength = tableData.length;
  const [checkedState, _setCheckedState] = useState(new Array(tablelength).fill(false));
  const [checkedAll, _setCheckedAll] = useState(false);
  const token = `Bearer ${getCookies('Token')}`;
  const [paginationData, setPaginationData] = useState([
    { page: 0, totalResult: 0, totalPages: 0 },
  ]);
  const [search, setSearchTerm] = useState(null);
  const [timer, setTimer] = useState(null);
  const [, setColumns] = useState([]);
  const [, setTableConfig] = useState();
  const [deletedData, setDeletedData] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [, setselected] = useState([]);
  const [details, setDetails] = useState();
  const [stats, setStats] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [reportLoading, setReportLoading] = useState(false);
  const [failedReportLoading, setFailedReportLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [verifyModal, setVerifyModal] = useState(false);
  const [PaymentShow, setPaymentShow] = useState(false);
  const [instructions, setInstructions] = useState(false);
  const [selectedDay, setSelectedDay] = useState(0);
  const [cancelEventModal, setCancelEventModal] = useState(false);
  const [cancelEventLoading, setCancelEventLoading] = useState(false);
  const [bookingToggleLoading, setBookingToggleLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState({});
  const [approvePreviewLoading, setApprovePreviewLoading] = useState({});
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    type: null,
    ticketId: null,
    attendeeName: null,
    willWaitlist: false,
    requireApproval: false,
  });
  const dataPerPage = 10;

  const getUsers = async () => {
    setTableLoading(true);
    const currentPage = pageNumView || pageNum;
    url = `${REACT_APP_API_FETCH_BOOKED_USERS}/${params.eventId}?`;
    url += `page=${currentPage}&limit=${dataPerPage}`;
    if (search !== null) {
      url += `&searchBy=${search}`;
    }
    try {
      const resp = await axios.get(url, {
        method: 'GET',
        headers: { Authorization: token },
      });
      if (resp.status === 200) {
        const response = resp.data.data.event;
        setTableData(response.results);
        setEventData(resp.data.data.show);
        const showData = resp.data.data.show;
        reset({
          publishablekey: showData?.stripePublicKey || '',
          secretKey: showData?.stripeSecretKey || '',
          webhookSecretKey: showData?.stripeWebhookKey || '',
          convinienceFee: showData?.convinienceFee ?? '',
          extraFee: showData?.extraFee ?? '',
          feeType: showData?.convinienceFeeType,
          feeFor: showData?.convinienceFeeFor,
        });
        setStats(resp.data.data.stats);
        setPaginationData({
          page: response.page,
          totalResult: response.totalResults,
          totalPages: response.totalPages,
        });
        if (pageNumView) {
          setPageNum(response.page);
          setPageNumView(null);
        } else if (response.page !== pageNum) {
          setPageNum(response.page);
        }
        const { Displayfields } = response;
        if (Array.isArray(Displayfields)) {
          setColumns(Displayfields);
        } else {
          const colkeys = Object.keys(Displayfields);
          setTableConfig(Displayfields);
          setColumns(colkeys);
        }
      }
    } catch {
      toast.error('Could not load table data.');
    } finally {
      setTableLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage !== pageNum) {
      setPageNumView(null);
      setPageNum(newPage);
    }
  };

  useEffect(() => {
    setSearchTerm(null);
    if (!pageNumView) {
      setPageNum(1);
    }
  }, []);

  useEffect(() => {
    setDashboardHeader('');
    const temp = section.replace(/\s+/g, '').toLowerCase();
    const permissions = getCookies('USERPERMISSION');
    permissions.forEach((val) => {
      if (val.section.toLowerCase() === temp) {
        setAddButtonPermissions({
          view: val.view ? val.view : false,
          edit: val.edit ? val.edit : false,
          create: val.create ? val.create : false,
          delete: val.delete ? val.delete : false,
          list: !!(val.view || val.edit || val.create || val.delete),
        });
      } else if (val.submenu) {
        val.submenu.forEach((element) => {
          if (element.section.toLowerCase() === temp) {
            setAddButtonPermissions({
              view: element.view ? element.view : false,
              edit: element.edit ? element.edit : false,
              create: element.create ? element.create : false,
              delete: element.delete ? element.delete : false,
              list: !!(element.view || element.edit || element.create || element.delete),
            });
          }
        });
      }
    });
    getUsers();
    const newarray = [];
    if (checkedAll) {
      for (let i = 0; i < tableData.length; i += 1) {
        newarray.push(tableData[i].id);
        checkedState[i] = true;
      }
      setselected(newarray);
    } else {
      for (let i = 0; i < tableData.length; i += 1) {
        checkedState[i] = false;
      }
      setselected([]);
    }
  }, [pageNum, search, deletedData, refreshData]);

  const onFilterTextChange = (e) => {
    const even = e;
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        const { value } = even.target;
        if (value.length > 0) {
          setPageNum(1);
          setSearchTerm(even.target.value.trim());
        } else {
          setSearchTerm(null);
        }
      }, 1000)
    );
  };

  const confirmDelete = () => {
    setDeleteLoading(true);
    const actionData = {};
    actionData.actionUrl = `booking/cancel-booking/${
      details?.ticketId?.id ? details?.ticketId?.id : details?.ticketId?._id
    }`;
    actionData.actionMethod = 'post';
    dispatch(Entry(actionData)).then((resp) => {
      if (resp.payload.code === 200) {
        if (eventData?.eventType === 'form') {
          toast.success('Booking has been cancelled.');
        } else {
          toast.success('Ticket has been cancelled.');
        }
        setDeletedData(details?.ticketId);
        setDeleteLoading(false);
        setDeleteModal(false);
      } else {
        toast.error('Something went wrong.');
        setDeleteModal(false);
        setDeleteLoading(false);
      }
    });
  };

  const confirmEnable = () => {
    setDeleteLoading(true);
    const actionData = {};
    if (details?.qrEnabled) {
      actionData.actionUrl = `shows/disable-qr/${details?.id}`;
    } else {
      actionData.actionUrl = `shows/enable-qr/${details?.id}`;
    }
    actionData.actionMethod = 'get';
    dispatch(Entry(actionData)).then((resp) => {
      if (resp.payload.code === 200) {
        if (resp?.payload?.data?.show?.qrEnabled) {
          toast.success('QR Scanner has been enabled!');
        } else {
          toast.success('QR Scanner has been disabled!');
        }
        setDeletedData(details?.qrEnabled);
        setDeleteLoading(false);
        setModal(false);
      } else {
        toast.error('Something went wrong.');
        setModal(false);
        setDeleteLoading(false);
      }
    });
  };

  const verifyTicket = () => {
    setDeleteLoading(true);
    const actionData = {};
    actionData.actionUrl = `shows/verify-ticket`;
    actionData.actionMethod = 'post';
    actionData.apiData = {
      ticketId: details?.id || details?._id,
      eventId: eventData?.id || eventData?._id,
    };
    dispatch(Entry(actionData)).then((resp) => {
      if (resp.payload.code === 200) {
        toast.success('Ticket has been verified.');
        setDeletedData(details?.ticketId);
        setDeleteLoading(false);
        setVerifyModal(false);
      } else {
        toast.error('Something went wrong.');
        setVerifyModal(false);
        setDeleteLoading(false);
      }
    });
  };

  function handleDelete(e, ticket) {
    setDetails(ticket);
    setDeleteModal(true);
  }

  function handleVerify(e, ticket) {
    setDetails(ticket);
    setVerifyModal(true);
  }
  function handleModal() {
    setModal(true);
    setDetails(eventData);
  }

  const supportsBookingPause = ['form', 'booking', 'non-seat-booking', 'rsvp'].includes(
    (eventData?.eventType || '').toLowerCase()
  );
  const isLiveOrUpcomingStatus = ['created', 'in progress'].includes(eventData?.status);
  const canPauseBooking =
    supportsBookingPause &&
    isLiveOrUpcomingStatus &&
    !eventData?.bookingPaused &&
    eventData?.bookingStatus !== 'ended';
  const canResumeBooking = eventData?.bookingPaused === true;

  const handleToggleBookingPause = async (action) => {
    const evId = eventData?.id || eventData?._id;
    if (!evId) return;
    setBookingToggleLoading(true);
    try {
      const endpoint =
        action === 'pause'
          ? `${SERVER_BASE_URL}/shows/pause-booking/${evId}`
          : `${SERVER_BASE_URL}/shows/resume-booking/${evId}`;
      const { data } = await axios.post(endpoint, {}, { headers: { Authorization: token } });
      const updatedShow = data?.data?.show;
      if (updatedShow) {
        setEventData((prev) => ({ ...prev, ...updatedShow }));
      }
      toast.success(action === 'pause' ? 'Booking paused.' : 'Booking resumed.');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to update booking status.');
    } finally {
      setBookingToggleLoading(false);
    }
  };

  const handleDeleteClose = () => setDeleteModal(false);
  const handleVerifyClose = () => setVerifyModal(false);
  const handleModalClose = () => setModal(false);
  const handleInstructionsClose = () => setInstructions(false);

  const getRowTicketId = (item) => item?.ticketId?.id || item?.ticketId?._id;

  const getRowAttendeeLabel = (item) =>
    item?.userName || item?.formResponseId?.name || item?.ticketId?.userName || 'this attendee';

  const handleOpenTicketConfirmModal = (type, ticketId, attendeeName) => {
    setConfirmModal({
      open: true,
      type,
      ticketId,
      attendeeName,
      willWaitlist: false,
      requireApproval: false,
    });
  };

  const handlePrepareApproveConfirm = async (ticketId, attendeeName) => {
    setApprovePreviewLoading((prev) => ({ ...prev, [ticketId]: true }));
    try {
      const res = await axios.get(`${SERVER_BASE_URL}/booking/approval-preview/${ticketId}`, {
        headers: { Authorization: `Bearer ${getCookies('Token')}` },
      });
      if (res.status !== 200 || res.data.code !== 200 || !res.data.data) {
        toast.error(res.data.message || 'Could not load approval details');
        return;
      }
      const prev = res.data.data;
      if (prev.cannotApproveSoldOut) {
        toast.error(
          'This event is at capacity and waitlist is not enabled. You cannot approve this registration.'
        );
        return;
      }
      const showWaitlistCopy = prev.willWaitlist === true && prev.requireApproval === true;
      setConfirmModal({
        open: true,
        type: 'approve',
        ticketId,
        attendeeName,
        willWaitlist: showWaitlistCopy,
        requireApproval: !!prev.requireApproval,
      });
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Could not load approval details.');
    } finally {
      setApprovePreviewLoading((prev) => ({ ...prev, [ticketId]: false }));
    }
  };

  const handleCloseTicketConfirmModal = () =>
    setConfirmModal({
      open: false,
      type: null,
      ticketId: null,
      attendeeName: null,
      willWaitlist: false,
      requireApproval: false,
    });

  const handleApproveTicketRow = async (tid) => {
    setApprovalLoading((prev) => ({ ...prev, [tid]: { ...prev[tid], approve: true } }));
    try {
      const res = await axios.post(
        `${SERVER_BASE_URL}/booking/approve-ticket/${tid}`,
        {},
        { headers: { Authorization: `Bearer ${getCookies('Token')}` } }
      );
      if (res.data.code === 200) {
        const st = res.data.data?.status;
        toast.success(
          st === 'waitlisted'
            ? 'Registration approved and placed on the waitlist.'
            : 'Registration approved successfully'
        );
        setRefreshData((r) => !r);
      } else {
        toast.error(res.data.message || 'Failed to approve registration');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to approve registration');
    } finally {
      setApprovalLoading((prev) => ({
        ...prev,
        [tid]: { ...prev[tid], approve: false },
      }));
    }
  };

  const handleRejectTicketRow = async (tid) => {
    setApprovalLoading((prev) => ({ ...prev, [tid]: { ...prev[tid], reject: true } }));
    try {
      const res = await axios.post(
        `${SERVER_BASE_URL}/booking/reject-ticket/${tid}`,
        {},
        { headers: { Authorization: `Bearer ${getCookies('Token')}` } }
      );
      if (res.data.code === 200) {
        toast.success('Registration rejected');
        setRefreshData((r) => !r);
      } else {
        toast.error(res.data.message || 'Failed to reject registration');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to reject registration');
    } finally {
      setApprovalLoading((prev) => ({
        ...prev,
        [tid]: { ...prev[tid], reject: false },
      }));
    }
  };

  const handleConfirmTicketModalAction = () => {
    const { type, ticketId } = confirmModal;
    handleCloseTicketConfirmModal();
    if (type === 'approve') handleApproveTicketRow(ticketId);
    else if (type === 'reject') handleRejectTicketRow(ticketId);
  };

  const actionView = (e, param) => {
    const encodeText = param.ticketId?.id || param.ticketId?._id;
    setPageNumView(pageNum);
    navigate(`/shows/view-ticket/${encodeText}`);
  };

  const onSubmit = (data) => {
    setDeleteLoading(true);
    const actionData = {};
    actionData.actionUrl = `shows/${eventData?.id}`;
    actionData.actionMethod = 'patch';
    actionData.apiData = {
      stripePublicKey:
        data?.publishablekey === '' ? eventData?.stripePublicKey : data?.publishablekey,
      stripeSecretKey: data?.secretKey === '' ? eventData?.stripeSecretKey : data?.secretKey,
      stripeWebhookKey:
        data?.webhookSecretKey === '' ? eventData?.stripeWebhookKey : data?.secretKey,
      convinienceFee:
        data?.convinienceFee === '' ? eventData?.convinienceFee : data?.convinienceFee,
      extraFee:
        data?.feeType === 'both'
          ? data?.extraFee === '' || data?.extraFee == null
            ? eventData?.extraFee ?? null
            : Number(data.extraFee)
          : null,
      convinienceFeeType: data?.feeType === '' ? eventData?.convinienceFeeType : data?.feeType,
      convinienceFeeFor: data?.feeFor === '' ? eventData?.convinienceFeeFor : data?.feeFor,
      cashBookingPercentage:
        data?.cashBookingPercentage === '' || data?.cashBookingPercentage == null
          ? eventData?.cashBookingPercentage ?? null
          : Number(data.cashBookingPercentage),
    };
    dispatch(Entry(actionData)).then((resp) => {
      if (resp.payload.code === 200) {
        toast.success('Payment details are updated successfully.');
        setDeleteLoading(false);
        setRefreshData(!refreshData);
        setPaymentShow(false);
        reset();
      } else {
        toast.error('Something went wrong.');
        setPaymentShow(false);
        reset();
        setDeleteLoading(false);
      }
    });
  };

  const createExcelReport = (reportData) => {
    const statistics = reportData.stats;
    const { show } = reportData;
    const wb = XLSX.utils.book_new();
    const eventType = show?.eventType;

    // ------------------ Statistics Sheet ------------------ //
    const cancellations =
      reportData.results?.filter((item) => item.ticketId?.paymentStatus === 'cancelled')?.length ||
      0;

    const financialRows = [
      ['Online Transactions', `$${(statistics?.totalOnline ?? 0).toFixed(2)}`],
      ['Cash Transactions', `$${(statistics?.totalCash ?? 0).toFixed(2)}`],
      ['Platform Commission', `$${(statistics?.totalConvinienceFee ?? 0).toFixed(2)}`],
      ['Payout to Event Manager', `$${(statistics?.payOut ?? 0).toFixed(2)}`],
      ['Refunds Issued', `$${(statistics?.totalRefunded ?? 0).toFixed(2)}`],
      ['Ticket Cancellations', cancellations.toString()],
      ['Total Donations', `$${(statistics?.totalDonation ?? 0).toFixed(2)}`],
      ['Donation Conv. Fee', `$${(statistics?.totalDonationConvFee ?? 0).toFixed(2)}`],
      ['Total Revenue', `$${(statistics?.totalAmountPaid ?? 0).toFixed(2)}`],
    ];

    let statsData;

    if (eventType === 'form') {
      statsData = [
        ['Metrics', 'Value'],
        ['Event Name', `${show?.eventName}`],
        ['Event Date', `${DateFormatter(show?.startDate, 'toEventViewDate')}`],
        ['Total Submissions', `${statistics?.totalBookings || '0'}`],
        [
          'Registrations Left',
          `${statistics?.totalSeatsAvailable ?? 0}/${statistics?.totalNumberOfTickets ?? 0}`,
        ],
        [
          'Final Check-ins',
          `${statistics?.verifiedTickets || '0'}/${statistics?.totalBookings || '0'}`,
        ],
        ...financialRows,
      ];
    } else if (eventType === 'booking') {
      statsData = [
        ['Metrics', 'Value'],
        ['Event Name', `${show?.eventName}`],
        ['Event Date', `${DateFormatter(show?.startDate, 'toEventViewDate')}`],
        ['Total Tickets Booked', `${statistics?.totalBookings || '0'}`],
        ['Total Participants', `${statistics?.totalPeople || '0'}`],
        [
          'Seats Available',
          `${statistics?.totalSeatsAvailable ?? 0}/${statistics?.totalNumberOfTickets ?? 0}`,
        ],
        [
          'Final Check-ins',
          `${statistics?.verifiedTickets || '0'}/${statistics?.totalBookings || '0'}`,
        ],
        ...financialRows,
      ];
    } else if (eventType === 'non-seat-booking') {
      const adultsRow =
        (statistics?.totalAdults ?? 0) > 0 ? [['Total Adults', `${statistics.totalAdults}`]] : [];
      const kidsRow =
        (statistics?.totalKids ?? 0) > 0 ? [['Total Kids', `${statistics.totalKids}`]] : [];
      statsData = [
        ['Metrics', 'Value'],
        ['Event Name', `${show?.eventName}`],
        ['Event Date', `${DateFormatter(show?.startDate, 'toEventViewDate')}`],
        ['Total Tickets Booked', `${statistics?.totalBookings || '0'}`],
        ['Total Participants', `${statistics?.totalPeople || '0'}`],
        ...adultsRow,
        ...kidsRow,
        [
          'Final Check-ins',
          `${statistics?.verifiedTickets || '0'}/${statistics?.totalBookings || '0'}`,
        ],
        ...financialRows,
      ];
    } else if (eventType === 'token') {
      statsData = [
        ['Metrics', 'Value'],
        ['Event Name', `${show?.eventName}`],
        ['Event Date', `${DateFormatter(show?.startDate, 'toEventViewDate')}`],
        ['Rows in this export', `${reportData.results?.length || 0}`],
      ];
    } else {
      statsData = [
        ['Metrics', 'Value'],
        ['Event Name', `${show?.eventName}`],
        ['Event Date', `${DateFormatter(show?.startDate, 'toEventViewDate')}`],
        ['Total Tickets Booked', `${statistics?.totalBookings || '0'}`],
        ['Total Participants', `${statistics?.totalPeople || '0'}`],
        ['Total Adults', `${statistics?.totalAdults || '0'}`],
        ['Total Kids', `${statistics?.totalKids || '0'}`],
        [
          'Final Check-ins',
          `${statistics?.verifiedTickets || '0'}/${statistics?.totalBookings || '0'}`,
        ],
        ...financialRows,
      ];
    }

    const statsWs = XLSX.utils.aoa_to_sheet(statsData);

    // Bold headers for Statistics sheet
    statsWs.A1.s = { font: { bold: true } };
    statsWs.B1.s = { font: { bold: true } };

    // Auto-adjust column widths for Statistics sheet
    const statsColWidths = [];
    statsData.forEach((row) => {
      row.forEach((cell, colIndex) => {
        const cellLength = cell ? cell.toString().length : 0;
        if (!statsColWidths[colIndex] || statsColWidths[colIndex] < cellLength) {
          statsColWidths[colIndex] = cellLength;
        }
      });
    });

    statsWs['!cols'] = statsColWidths.map((width) => ({ wch: width + 2 }));

    XLSX.utils.book_append_sheet(wb, statsWs, 'Statistics');

    // ------------------ Attendees Sheet ------------------ //

    // ── Detect optional column groups ──
    const hasSeats = reportData.results?.some(
      (item) => item?.ticketId?.seatsBooked && item?.ticketId?.seatsBooked !== ''
    );
    const hasParticipants = reportData.results?.some(
      (item) => item?.formResponseId?.participants?.length > 0
    );
    const hasWard = reportData.results?.some(
      (item) => item?.formResponseId?.ward && item?.formResponseId?.ward !== ''
    );
    const hasGuests = reportData.results?.some(
      (item) => item?.formResponseId?.numberOfGuests && item?.formResponseId?.numberOfGuests !== ''
    );

    // For form events: detect dynamic response labels from the responses[] array
    const isNewFormModel = reportData.results?.some((item) =>
      Array.isArray(item?.formResponseId?.responses)
    );
    const dynamicResponseLabels = isNewFormModel
      ? [
          ...new Set(
            reportData.results
              .flatMap((item) => (item?.formResponseId?.responses || []).map((r) => r.label))
              .filter(Boolean)
          ),
        ]
      : [];

    // ── Build headers & rows per event type ──
    let attendeeHeaders = [];
    let attendeeData = [];

    if (eventType === 'token') {
      attendeeHeaders = ['User Name', 'Date Joined', 'Tokens', 'Status'];
      attendeeData = [attendeeHeaders];
      reportData.results?.forEach((item) => {
        const booked = item?.ticketId?.bookedDate || item?.createdAt;
        let statusLabel = 'Pending';
        if (item.paymentStatus === 'booked') statusLabel = 'Joined';
        else if (item.paymentStatus === 'cancelled') statusLabel = 'Cancelled';
        else if (item.paymentStatus === 'ticket-pending') statusLabel = 'Pending';
        else if (item.paymentStatus === 'waitlisted') statusLabel = 'Waitlisted';
        else if (item.paymentStatus) statusLabel = CapitalizeFirstLetter(item.paymentStatus);
        const hasTok = item.tokensLeft != null && item.tokensLeft !== '';
        const tok = hasTok ? String(item.tokensLeft) : '';
        attendeeData.push([
          item.userName || item?.ticketId?.userName || '',
          booked ? DateFormatter(booked, 'toLocaleDateString') : '',
          tok,
          statusLabel,
        ]);
      });
    } else if (eventType === 'form') {
      // ── Form / Registration events ──
      attendeeHeaders = [
        'SL No',
        'Booking Id',
        'Name',
        'Email',
        'Phone',
        'Paid Amount',
        'Convenience Fee',
        'Coupon Discount',
        'Donation Amount',
        'Donation Conv. Fee',
        'Payment Mode',
        'Check-in Status',
        'Cancellation Status',
        ...dynamicResponseLabels,
      ];

      // Legacy flat-schema optional columns (older events)
      if (!isNewFormModel) {
        if (hasWard)
          attendeeHeaders.push(
            'Partner Name',
            'Donation Amount',
            'Ward',
            'Parish Id',
            'Interesting Facts',
            'Ramp Walk'
          );
        if (hasGuests) attendeeHeaders.push('Visiting Parents', 'Kids Under 5');
        if (hasParticipants)
          attendeeHeaders.push(
            'Attendee Age',
            'Attendee Gender',
            'Additional Participants',
            'Distance',
            'Booking For'
          );
      }

      attendeeData = [attendeeHeaders];
      reportData.results?.forEach((item, index) => {
        const row = [
          (index + 1).toString(),
          item?.ticketId?.bookingId || '',
          item?.ticketId?.userName || item?.formResponseId?.name || '',
          item?.ticketId?.email || item?.formResponseId?.email || 'Not Added',
          item?.ticketId?.phone || item?.formResponseId?.phone || 'Not Added',
          `$${(item?.ticketId?.totalAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.convinienceFee ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.couponDiscount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationConvFee ?? 0).toFixed(2)}`,
          CapitalizeFirstLetter(item?.ticketId?.paymentMethod) || '',
          item?.isVerified ? 'Checked In' : 'Not Checked In',
          item?.ticketId?.paymentStatus === 'booked' ? 'Not Cancelled' : 'Cancelled',
        ];

        // Dynamic responses (new FormResponse model)
        if (isNewFormModel) {
          dynamicResponseLabels.forEach((lbl) => {
            const match = (item?.formResponseId?.responses || []).find((r) => r.label === lbl);
            row.push(match?.response ?? '');
          });
        } else {
          // Legacy flat fields
          if (hasWard) {
            row.push(item?.formResponseId?.partnerName || '-');
            row.push(
              item?.formResponseId?.donationAmount != null
                ? `$${Number(item.formResponseId.donationAmount).toFixed(2)}`
                : '$0.00'
            );
            row.push(item?.formResponseId?.ward || '');
            row.push(item?.formResponseId?.parishId || 'Not Added');
            row.push(
              item?.formResponseId?.facts
                ? item.formResponseId.facts.replace(/(.{80})/g, '$1\n')
                : 'Not Added'
            );
            row.push(item?.formResponseId?.isRampWalk || 'Not Added');
          }
          if (hasGuests) {
            row.push(item?.formResponseId?.numberOfGuests || '0');
            row.push(item?.formResponseId?.numberOfKids5 || '0');
          }
          if (hasParticipants) {
            row.push(item?.formResponseId?.age || 'Not Added');
            row.push(item?.formResponseId?.gender || 'Not Added');
            row.push(
              item?.formResponseId?.participants?.length
                ? item.formResponseId.participants
                    .map((p) =>
                      [p?.name, p?.email, p?.age, p?.phone, p?.gender].filter(Boolean).join(' | ')
                    )
                    .join('\n')
                : 'Not Added'
            );
            row.push(item?.formResponseId?.distance || 'Not Added');
            row.push(item?.formResponseId?.anotherName || 'NA');
          }
        }

        attendeeData.push(row);
      });
    } else if (eventType === 'booking') {
      // ── Seat Booking events ──
      attendeeHeaders = [
        'SL No',
        'Booking Id',
        'Registered User',
        'Registered Email',
        'Registered Phone',
        'Paid Amount',
        'Convenience Fee',
        'Coupon Discount',
        'Donation Amount',
        'Donation Conv. Fee',
        'Payment Mode',
        'No. of Participants',
        'Check-in Status',
        'Cancellation Status',
      ];
      if (hasSeats) attendeeHeaders.push('Seats Booked');
      if (hasParticipants) attendeeHeaders.push('Additional Participants', 'Booked For');

      attendeeData = [attendeeHeaders];
      reportData.results?.forEach((item, index) => {
        const row = [
          (index + 1).toString(),
          item?.ticketId?.bookingId || '',
          item?.userId?.name || item?.ticketId?.userName || '',
          item?.userId?.email || item?.ticketId?.email || '',
          item?.userId?.phone || item?.ticketId?.phone || '',
          `$${(item?.ticketId?.totalAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.convinienceFee ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.couponDiscount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationConvFee ?? 0).toFixed(2)}`,
          CapitalizeFirstLetter(item?.ticketId?.paymentMethod) || '',
          `${item?.ticketId?.numberOfTicketsBooked ?? 0}`,
          item?.isVerified ? 'Checked In' : 'Not Checked In',
          item?.ticketId?.paymentStatus === 'booked' ? 'Not Cancelled' : 'Cancelled',
        ];
        if (hasSeats) row.push(item?.ticketId?.seatsBooked || '-');
        if (hasParticipants) {
          row.push(
            item?.formResponseId?.participants?.length
              ? item.formResponseId.participants
                  .filter((p) => p?.name?.trim() || p?.email?.trim() || p?.phone?.length > 4)
                  .map((p) =>
                    [
                      p?.name?.trim() || '-',
                      p?.email?.trim() || '-',
                      p?.phone?.length > 4 ? p.phone : '-',
                    ].join(' | ')
                  )
                  .join(',\n')
              : 'Not Added'
          );
          row.push(
            item?.ticketId?.bookingForSomeone
              ? `${item?.ticketId?.userName} | ${item?.ticketId?.email} | ${item?.ticketId?.phone}`
              : 'Self'
          );
        }
        attendeeData.push(row);
      });
    } else if (eventType === 'non-seat-booking') {
      // ── Non-Seat Booking events ──
      const hasKids = reportData.results?.some((item) => (item?.ticketId?.numberOfKids ?? 0) > 0);
      attendeeHeaders = [
        'SL No',
        'Booking Id',
        'Name',
        'Email',
        'Phone',
        'Paid Amount',
        'Convenience Fee',
        'Coupon Discount',
        'Donation Amount',
        'Donation Conv. Fee',
        'Payment Mode',
        'Participants',
      ];
      if (hasKids) attendeeHeaders.push('Kids');
      attendeeHeaders.push('Check-in Status', 'Cancellation Status');

      attendeeData = [attendeeHeaders];
      reportData.results?.forEach((item, index) => {
        const row = [
          (index + 1).toString(),
          item?.ticketId?.bookingId || '',
          item?.ticketId?.userName || '',
          item?.ticketId?.email || '',
          item?.ticketId?.phone || '',
          `$${(item?.ticketId?.totalAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.convinienceFee ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.couponDiscount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationConvFee ?? 0).toFixed(2)}`,
          CapitalizeFirstLetter(item?.ticketId?.paymentMethod) || '',
          `${item?.ticketId?.numberOfTicketsBooked ?? 0}`,
        ];
        if (hasKids) row.push(`${item?.ticketId?.numberOfKids ?? 0}`);
        row.push(
          item?.isVerified ? 'Checked In' : 'Not Checked In',
          item?.ticketId?.paymentStatus === 'booked' ? 'Not Cancelled' : 'Cancelled'
        );
        attendeeData.push(row);
      });
    } else {
      // ── Fallback for other event types ──
      attendeeHeaders = [
        'SL No',
        'Booking Id',
        'Registered User',
        'Registered Email',
        'Registered Phone',
        'Paid Amount',
        'Convenience Fee',
        'Coupon Discount',
        'Donation Amount',
        'Donation Conv. Fee',
        'Payment Mode',
        'No. of Participants',
        'Check-in Status',
        'Cancellation Status',
      ];
      attendeeData = [attendeeHeaders];
      reportData.results?.forEach((item, index) => {
        attendeeData.push([
          (index + 1).toString(),
          item?.ticketId?.bookingId || '',
          item?.userId?.name || item?.ticketId?.userName || '',
          item?.userId?.email || item?.ticketId?.email || '',
          item?.userId?.phone || item?.ticketId?.phone || '',
          `$${(item?.ticketId?.totalAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.convinienceFee ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.couponDiscount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationAmount ?? 0).toFixed(2)}`,
          `$${(item?.ticketId?.donationConvFee ?? 0).toFixed(2)}`,
          CapitalizeFirstLetter(item?.ticketId?.paymentMethod) || '',
          `${item?.ticketId?.numberOfTicketsBooked ?? 0}`,
          item?.isVerified ? 'Checked In' : 'Not Checked In',
          item?.ticketId?.paymentStatus === 'booked' ? 'Not Cancelled' : 'Cancelled',
        ]);
      });
    }

    const attendeeWs = XLSX.utils.aoa_to_sheet(attendeeData);

    // Bold headers for Attendees sheet
    attendeeHeaders.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      if (attendeeWs[cellRef]) {
        attendeeWs[cellRef].s = { font: { bold: true } };
      }
    });

    // Auto-adjust column widths for Attendees sheet
    const attendeeColWidths = [];
    attendeeData.forEach((row) => {
      row.forEach((cell, colIndex) => {
        const cellLength = cell ? cell.toString().length : 0;
        if (!attendeeColWidths[colIndex] || attendeeColWidths[colIndex] < cellLength) {
          attendeeColWidths[colIndex] = cellLength;
        }
      });
    });

    const factsColIndex = attendeeHeaders.indexOf('Interesting Facts');
    const factsCol1Index = attendeeHeaders.indexOf('Additional Participants');
    const factsCol2Index = attendeeHeaders.indexOf('Seats Booked');
    if (factsColIndex !== -1) {
      attendeeColWidths[factsColIndex] = 50;
    }
    if (factsCol1Index !== -1) {
      attendeeColWidths[factsCol1Index] = 60;
    }
    if (factsCol2Index !== -1) {
      attendeeColWidths[factsCol2Index] = 70;
    }

    attendeeWs['!cols'] = attendeeColWidths.map((width) => ({ wch: width + 2 }));

    XLSX.utils.book_append_sheet(wb, attendeeWs, 'Attendees');

    // ------------------ Save File ------------------ //
    XLSX.writeFile(wb, `Final_Report_For_${show?.eventName.replace(/[^a-z0-9]/gi, '_')}.xlsx`);
    toast.success('Report downloaded successfully!');
  };

  // ── Audit log Excel (for booking events) ──
  const createExcelAuditReport = (logs, evtName) => {
    const wb = XLSX.utils.book_new();
    const headers = [
      'Timestamp',
      'User Name',
      'Role',
      'Action Taken',
      'Event/Order ID',
      'IP Address',
    ];
    const rows = (logs || []).map((log) => {
      const timestamp = [log.date, log.time].filter(Boolean).join(', ');
      const userName = [log.name, log.email].filter(Boolean).join('\n');
      const role = log.role ? log.role.charAt(0).toUpperCase() + log.role.slice(1) : '';
      const eventOrderId = [
        log.eventName || evtName || '',
        log.bookingId ? `Booking ID: ${log.bookingId}` : '',
      ]
        .filter(Boolean)
        .join('\n');
      const ipAddress = [log.ipAddress, log.location].filter(Boolean).join('\n');
      return [timestamp, userName, role, log.action || '', eventOrderId, ipAddress];
    });
    const sheetData = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    headers.forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
      if (ws[cellRef]) ws[cellRef].s = { font: { bold: true } };
    });
    const colWidths = [];
    sheetData.forEach((row) => {
      row.forEach((cell, colIndex) => {
        const len = cell ? cell.toString().length : 0;
        if (!colWidths[colIndex] || colWidths[colIndex] < len) colWidths[colIndex] = len;
      });
    });
    ws['!cols'] = colWidths.map((width) => ({ wch: Math.max(width + 2, 12) }));
    XLSX.utils.book_append_sheet(wb, ws, 'Audit Logs');
    XLSX.writeFile(wb, `Audit_Log_For_${(evtName || 'Event').replace(/[^a-z0-9]/gi, '_')}.xlsx`);
    toast.success('Audit log report downloaded!');
  };

  // ── Pending tickets Excel (for form and non-seat-booking events) ──
  const createExcelPendingTicketsReport = (reportData) => {
    const { show } = reportData;
    const wb = XLSX.utils.book_new();
    const logEventType = show?.eventType;
    const results = reportData.results || [];

    // ── Helper: apply bold headers + auto column widths ──
    const finalizeSheet = (ws, sheetHeaders, sheetData) => {
      sheetHeaders.forEach((_, i) => {
        const ref = XLSX.utils.encode_cell({ r: 0, c: i });
        if (ws[ref]) ws[ref].s = { font: { bold: true } };
      });
      const colWidths = [];
      sheetData.forEach((row) => {
        row.forEach((cell, i) => {
          const len = cell ? cell.toString().length : 0;
          if (!colWidths[i] || colWidths[i] < len) colWidths[i] = len;
        });
      });
      ws['!cols'] = colWidths.map((w) => ({ wch: Math.max(w + 2, 12) }));
    };

    // ── Helper: format initiated date ──
    const formatDate = (ticket) => {
      const d = ticket?.createdAt || ticket?.bookedDate;
      if (!d) return '';
      const iso = new Date(d).toISOString();
      return `${DateFormatter(iso, 'toEventViewDate')}, ${DateFormatter(iso, 'toTime')}`;
    };

    // ── Helper: format tier breakdown from ticket.tierDetails or ticket.booking ──
    const formatTiers = (ticket) => {
      if (ticket?.tierDetails?.length) {
        return ticket.tierDetails
          .map((t) => `${t.label}: ${t.quantity} ($${(t.price ?? 0).toFixed(2)} each)`)
          .join('\n');
      }
      if (ticket?.booking?.length) {
        return ticket.booking.map((b) => `${b.section}: ${b.count}`).join('\n');
      }
      return '';
    };

    if (logEventType === 'non-seat-booking') {
      // ── Non-seat-booking: tier breakdown + kids ──
      const hasTiers = results.some(
        (item) => item?.ticketId?.tierDetails?.length || item?.ticketId?.booking?.length
      );
      const hasKids = results.some((item) => (item?.ticketId?.numberOfKids ?? 0) > 0);

      const headers = ['SL No', 'Booking ID', 'Name', 'Email', 'Phone', 'Amount', 'Payment Method'];
      if (hasTiers) headers.push('Tier Breakdown');
      else headers.push('Participants');
      if (hasKids) headers.push('Kids');
      headers.push('Initiated At', 'Status');

      const sheetData = [headers];
      results.forEach((item, index) => {
        const ticket = item?.ticketId || {};
        const row = [
          (index + 1).toString(),
          ticket?.bookingId || '',
          ticket?.userName || item?.userId?.name || '',
          ticket?.email || item?.userId?.email || '',
          ticket?.phone || item?.userId?.phone || '',
          `$${(ticket?.totalAmount ?? 0).toFixed(2)}`,
          CapitalizeFirstLetter(ticket?.paymentMethod) || '',
        ];
        if (hasTiers) {
          row.push(formatTiers(ticket));
        } else {
          row.push(`${ticket?.numberOfTicketsBooked ?? 0}`);
        }
        if (hasKids) row.push(`${ticket?.numberOfKids ?? 0}`);
        row.push(formatDate(ticket), 'Pending');
        sheetData.push(row);
      });

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      finalizeSheet(ws, headers, sheetData);
      XLSX.utils.book_append_sheet(wb, ws, 'Pending Tickets');
    } else {
      // ── Form: dynamic responses from formResponseId.responses ──
      const responseLabels = [
        ...new Set(
          results
            .flatMap((item) => (item?.formResponseId?.responses || []).map((r) => r.label))
            .filter(Boolean)
        ),
      ];

      const headers = [
        'SL No',
        'Booking ID',
        'Name',
        'Email',
        'Phone',
        'Amount',
        'Payment Method',
        ...responseLabels,
        'Initiated At',
        'Status',
      ];

      const sheetData = [headers];
      results.forEach((item, index) => {
        const ticket = item?.ticketId || {};
        const fr = item?.formResponseId || {};
        const row = [
          (index + 1).toString(),
          ticket?.bookingId || '',
          ticket?.userName || fr?.name || item?.userId?.name || '',
          ticket?.email || fr?.email || item?.userId?.email || '',
          ticket?.phone || fr?.phone || item?.userId?.phone || '',
          `$${(ticket?.totalAmount ?? 0).toFixed(2)}`,
          CapitalizeFirstLetter(ticket?.paymentMethod) || '',
        ];
        responseLabels.forEach((lbl) => {
          const match = (fr?.responses || []).find((r) => r.label === lbl);
          row.push(match?.response ?? '');
        });
        row.push(formatDate(ticket), 'Pending');
        sheetData.push(row);
      });

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      finalizeSheet(ws, headers, sheetData);
      XLSX.utils.book_append_sheet(wb, ws, 'Pending Submissions');
    }

    XLSX.writeFile(
      wb,
      `Pending_Tickets_For_${(show?.eventName || 'Event').replace(/[^a-z0-9]/gi, '_')}.xlsx`
    );
    toast.success('Pending tickets report downloaded!');
  };

  const exportStats = async (eventId) => {
    try {
      setReportLoading(true);

      const response = await fetch(`${SERVER_BASE_URL}/shows/bookings-stats-report/${eventId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getCookies('Token')}`,
        },
      });

      const data = await response.json();

      if (data.code === 200) {
        // Merge: server stats as base (has totalRefunded, totalDonation, etc.),
        // then overlay component state stats so any UI-computed fields win.
        const mergedStats = { ...(data.data.stats || {}), ...(stats || {}) };
        createExcelReport({ ...data.data, stats: mergedStats });
      } else {
        toast.error('Failed to fetch report data');
      }
    } catch (error) {
      toast.error('Error generating report');
    } finally {
      setReportLoading(false);
    }
  };

  const exportLogs = async (eventId) => {
    const evtType = eventData?.eventType;
    try {
      setFailedReportLoading(true);

      if (evtType === 'booking') {
        // Booking events → audit logs
        const auditParams = new URLSearchParams({ eventId, limit: '1000', page: '1' });
        const response = await fetch(`${SERVER_BASE_URL}/auditlogs?${auditParams.toString()}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getCookies('Token')}`,
          },
        });
        const data = await response.json();
        if (data.success && data.data) {
          const logs = data.data.results || [];
          if (logs.length === 0) {
            toast.info('No audit logs found for this event.');
            return;
          }
          createExcelAuditReport(logs, eventData?.eventName || 'Event');
        } else {
          toast.error(data.message || 'Failed to fetch audit logs');
        }
      } else {
        // Form / non-seat-booking → pending tickets
        const response = await fetch(`${SERVER_BASE_URL}/shows/pending-bookings/${eventId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getCookies('Token')}`,
          },
        });
        const data = await response.json();
        if (data.code === 200) {
          const result = data.data?.result;
          if (!result?.results?.length) {
            toast.info('No abandoned bookings found for this event.');
            return;
          }
          createExcelPendingTicketsReport(result);
        } else {
          toast.error('Failed to fetch pending tickets');
        }
      }
    } catch (error) {
      toast.error('Error generating log report');
    } finally {
      setFailedReportLoading(false);
    }
  };

  const handleCancelEvent = async () => {
    const eventId = eventData?.id || eventData?._id;
    if (!eventId) return;
    setCancelEventLoading(true);
    try {
      const response = await axios.post(
        `${SERVER_BASE_URL}/admin/events/${eventId}/cancel`,
        {},
        { headers: { Authorization: token } }
      );
      if (response.data?.success) {
        toast.success('Event has been cancelled and refunds have been initiated.');
        setCancelEventModal(false);
        getUsers();
      } else {
        toast.error(response.data?.message || 'Failed to cancel the event.');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'An error occurred while cancelling the event.');
    } finally {
      setCancelEventLoading(false);
    }
  };

  return (
    <div className={styles[bodyStyle]}>
      <InstructionsModal show={instructions} handleClose={handleInstructionsClose} />
      <PaymentSettingsModal
        show={PaymentShow}
        onHide={() => {
          reset();
          setPaymentShow(false);
        }}
        control={control}
        register={register}
        webhookUrl={`${SERVER_URL_WEB}/webhook-event/${encodeURIComponent(eventData?.eventName)}`}
        onSubmit={handleSubmit(onSubmit)}
        loading={deleteLoading}
      />

      <CancelTicket
        show={deleteModal}
        handleClose={handleDeleteClose}
        onConfirm={confirmDelete}
        onCancel={handleDeleteClose}
        message="Do you really want to cancel this ticket? "
        loading={deleteLoading}
      />
      <CancelTicket
        show={cancelEventModal}
        handleClose={() => setCancelEventModal(false)}
        onConfirm={handleCancelEvent}
        onCancel={() => setCancelEventModal(false)}
        message={`Are you sure you want to cancel the event "${eventData?.eventName}"? This will refund all booked tickets and cannot be undone.`}
        loading={cancelEventLoading}
      />
      <ConfirmAlertPopup
        show={modal}
        handleClose={handleModalClose}
        onConfirm={confirmEnable}
        onCancel={handleModalClose}
        message={
          eventData?.qrEnabled
            ? 'Are you sure to disable QR scanner?'
            : 'Are you sure to enable QR scanner?'
        }
        loading={deleteLoading}
      />
      <VerifyModal
        show={verifyModal}
        handleClose={handleVerifyClose}
        onConfirm={verifyTicket}
        onCancel={handleVerifyClose}
        loading={deleteLoading}
      />
      {confirmModal.open && (
        <div
          className={styles.ticketConfirmOverlay}
          role="dialog"
          aria-modal="true"
          aria-labelledby="ticketConfirmModalTitle"
          onClick={handleCloseTicketConfirmModal}
          onKeyDown={(e) => {
            if (e.key === 'Escape') handleCloseTicketConfirmModal();
          }}
        >
          <div className={styles.ticketConfirmCard} onClick={(e) => e.stopPropagation()}>
            <div
              className={`${styles.ticketConfirmIconWrap} ${
                confirmModal.type === 'approve'
                  ? styles.ticketConfirmIconApprove
                  : styles.ticketConfirmIconReject
              }`}
            >
              {confirmModal.type === 'approve' ? (
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M23 7L11 19L5 13"
                    stroke="#166534"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M4 4L20 20M20 4L4 20"
                    stroke="#991b1b"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </div>
            <h3 id="ticketConfirmModalTitle" className={styles.ticketConfirmTitle}>
              {confirmModal.type === 'approve' ? 'Approve Registration?' : 'Reject Registration?'}
            </h3>
            {confirmModal.type === 'approve' && confirmModal.willWaitlist ? (
              <p className={styles.ticketWaitlistNote}>
                <strong>Event is at capacity.</strong> Approving will place this registration on the{' '}
                <strong>waitlist</strong> (not a confirmed seat).
                <br />
                They will be notified if a spot opens.
              </p>
            ) : null}
            <p className={styles.ticketConfirmBody}>
              {confirmModal.type === 'approve' ? (
                <>
                  Are you sure you want to <strong>approve</strong> this registration
                  {confirmModal.attendeeName ? (
                    <>
                      {' '}
                      for <strong>{confirmModal.attendeeName}</strong>
                    </>
                  ) : null}
                  ?
                  {confirmModal.willWaitlist
                    ? ' No ticket confirmation email will be sent while they remain on the waitlist.'
                    : ' A confirmation email with their ticket will be sent.'}
                </>
              ) : (
                <>
                  Are you sure you want to <strong>reject</strong> this registration
                  {confirmModal.attendeeName ? (
                    <>
                      {' '}
                      for <strong>{confirmModal.attendeeName}</strong>
                    </>
                  ) : null}
                  ? A cancellation email will be sent and any payment will be refunded.
                </>
              )}
            </p>
            <div className={styles.ticketConfirmActions}>
              <button
                type="button"
                className={styles.ticketConfirmCancelBtn}
                onClick={handleCloseTicketConfirmModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className={
                  confirmModal.type === 'approve'
                    ? styles.ticketConfirmApproveBtn
                    : styles.ticketConfirmRejectBtn
                }
                onClick={handleConfirmTicketModalAction}
                disabled={
                  confirmModal.ticketId &&
                  (approvalLoading[confirmModal.ticketId]?.approve ||
                    approvalLoading[confirmModal.ticketId]?.reject)
                }
              >
                {confirmModal.type === 'approve' ? 'Yes, Approve' : 'Yes, Reject'}
              </button>
            </div>
          </div>
        </div>
      )}
      {addButtonPermissions.list && (
        <div
          className={styles[dashboardStyle]}
          style={{ minHeight: '100vh' }}
          id={styles.dashboardcont2}
        >
          <div className="container-fluid" id={styles.container}>
            <div className={styles.user_tb_hd}>
              <div
                value="Back"
                onClick={() => {
                  navigate(-1);
                }}
                className={`${styles.arrowback} backBtn`}
              >
                <svg
                  className="mr-1"
                  width="17"
                  height="14"
                  viewBox="0 0 17 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 6.00003H3.64L7.27 1.64003C7.43974 1.43581 7.5214 1.17253 7.49702 0.908108C7.47264 0.643682 7.34422 0.39977 7.14 0.230032C6.93578 0.060293 6.6725 -0.0213689 6.40808 0.0030108C6.14365 0.0273905 5.89974 0.155815 5.73 0.360032L0.73 6.36003C0.696361 6.40776 0.666279 6.45789 0.64 6.51003C0.64 6.56003 0.64 6.59003 0.57 6.64003C0.524674 6.75469 0.500941 6.87674 0.5 7.00003C0.500941 7.12332 0.524674 7.24537 0.57 7.36003C0.57 7.41003 0.57 7.44003 0.64 7.49003C0.666279 7.54217 0.696361 7.59231 0.73 7.64003L5.73 13.64C5.82402 13.7529 5.94176 13.8437 6.07485 13.9059C6.20793 13.9681 6.35309 14.0003 6.5 14C6.73365 14.0005 6.96009 13.9191 7.14 13.77C7.24126 13.6861 7.32496 13.583 7.38631 13.4666C7.44766 13.3503 7.48546 13.223 7.49754 13.092C7.50961 12.961 7.49573 12.829 7.45669 12.7034C7.41764 12.5777 7.3542 12.4611 7.27 12.36L3.64 8.00003H15.5C15.7652 8.00003 16.0196 7.89467 16.2071 7.70714C16.3946 7.5196 16.5 7.26525 16.5 7.00003C16.5 6.73482 16.3946 6.48046 16.2071 6.29292C16.0196 6.10539 15.7652 6.00003 15.5 6.00003Z"
                    fill=""
                  />
                </svg>
                Back
              </div>
              <div className={styles.onboardsty}>
                <div className={styles.info_contain}>
                  {/* <div className={styles.info_icon}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_8817_38163)">
                        <path
                          d="M11.3366 14.0909C11.1322 14.11 10.9269 14.0638 10.7503 13.9591C10.6212 13.8266 10.5593 13.6426 10.5821 13.4591C10.5869 13.3062 10.6051 13.1541 10.6366 13.0045C10.6671 12.8329 10.7066 12.663 10.7548 12.4954L11.2912 10.65C11.3465 10.4678 11.383 10.2805 11.4003 10.0909C11.4003 9.88632 11.4275 9.74539 11.4275 9.66359C11.4389 9.29902 11.2833 8.94918 11.0048 8.71359C10.6623 8.45062 10.2357 8.32136 9.80481 8.34996C9.49602 8.35461 9.18961 8.40515 8.8957 8.49996C8.57449 8.59996 8.2366 8.71964 7.88207 8.85906L7.72754 9.45906C7.83207 9.42269 7.95938 9.38179 8.1048 9.33632C8.24355 9.29523 8.38738 9.27378 8.53207 9.27269C8.73504 9.2507 8.93934 9.30054 9.10934 9.41359C9.22481 9.55136 9.27898 9.73035 9.25934 9.90906C9.25883 10.0619 9.24207 10.2143 9.20934 10.3636C9.1775 10.5227 9.1366 10.6909 9.0866 10.8681L8.5457 12.7227C8.50211 12.895 8.46723 13.0695 8.44117 13.2454C8.41992 13.396 8.4093 13.5478 8.40934 13.6999C8.40711 14.067 8.57496 14.4144 8.86387 14.6408C9.21168 14.9079 9.64434 15.0403 10.082 15.0136C10.3902 15.0199 10.6974 14.9753 10.9911 14.8817C11.2487 14.7938 11.5927 14.6681 12.023 14.5044L12.1684 13.9317C12.0519 13.9801 11.9318 14.0196 11.8093 14.0499C11.6544 14.0853 11.4954 14.099 11.3366 14.0909Z"
                          fill="#0C5460"
                        />
                        <path
                          d="M11.9041 5.3409C11.6568 5.11372 11.3308 4.99149 10.995 5C10.6594 4.99243 10.3338 5.11454 10.0859 5.3409C9.63156 5.7327 9.58081 6.41868 9.97265 6.87309C10.0076 6.9136 10.0454 6.95145 10.0859 6.98637C10.6036 7.44938 11.3865 7.44938 11.9041 6.98637C12.3585 6.59071 12.4061 5.90165 12.0104 5.44727C11.9775 5.40942 11.942 5.37387 11.9041 5.3409Z"
                          fill="#0C5460"
                        />
                        <path
                          d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM10 19.0909C4.97922 19.0909 0.909102 15.0208 0.909102 10C0.909102 4.97922 4.97922 0.909102 10 0.909102C15.0208 0.909102 19.0909 4.97922 19.0909 10C19.0909 15.0208 15.0208 19.0909 10 19.0909Z"
                          fill="#0C5460"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_8817_38163">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div> */}
                  <div className={styles.info_content}>
                    <p>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_8817_38163)">
                          <path
                            d="M11.3366 14.0909C11.1322 14.11 10.9269 14.0638 10.7503 13.9591C10.6212 13.8266 10.5593 13.6426 10.5821 13.4591C10.5869 13.3062 10.6051 13.1541 10.6366 13.0045C10.6671 12.8329 10.7066 12.663 10.7548 12.4954L11.2912 10.65C11.3465 10.4678 11.383 10.2805 11.4003 10.0909C11.4003 9.88632 11.4275 9.74539 11.4275 9.66359C11.4389 9.29902 11.2833 8.94918 11.0048 8.71359C10.6623 8.45062 10.2357 8.32136 9.80481 8.34996C9.49602 8.35461 9.18961 8.40515 8.8957 8.49996C8.57449 8.59996 8.2366 8.71964 7.88207 8.85906L7.72754 9.45906C7.83207 9.42269 7.95938 9.38179 8.1048 9.33632C8.24355 9.29523 8.38738 9.27378 8.53207 9.27269C8.73504 9.2507 8.93934 9.30054 9.10934 9.41359C9.22481 9.55136 9.27898 9.73035 9.25934 9.90906C9.25883 10.0619 9.24207 10.2143 9.20934 10.3636C9.1775 10.5227 9.1366 10.6909 9.0866 10.8681L8.5457 12.7227C8.50211 12.895 8.46723 13.0695 8.44117 13.2454C8.41992 13.396 8.4093 13.5478 8.40934 13.6999C8.40711 14.067 8.57496 14.4144 8.86387 14.6408C9.21168 14.9079 9.64434 15.0403 10.082 15.0136C10.3902 15.0199 10.6974 14.9753 10.9911 14.8817C11.2487 14.7938 11.5927 14.6681 12.023 14.5044L12.1684 13.9317C12.0519 13.9801 11.9318 14.0196 11.8093 14.0499C11.6544 14.0853 11.4954 14.099 11.3366 14.0909Z"
                            fill="#0C5460"
                          />
                          <path
                            d="M11.9041 5.3409C11.6568 5.11372 11.3308 4.99149 10.995 5C10.6594 4.99243 10.3338 5.11454 10.0859 5.3409C9.63156 5.7327 9.58081 6.41868 9.97265 6.87309C10.0076 6.9136 10.0454 6.95145 10.0859 6.98637C10.6036 7.44938 11.3865 7.44938 11.9041 6.98637C12.3585 6.59071 12.4061 5.90165 12.0104 5.44727C11.9775 5.40942 11.942 5.37387 11.9041 5.3409Z"
                            fill="#0C5460"
                          />
                          <path
                            d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM10 19.0909C4.97922 19.0909 0.909102 15.0208 0.909102 10C0.909102 4.97922 4.97922 0.909102 10 0.909102C15.0208 0.909102 19.0909 4.97922 19.0909 10C19.0909 15.0208 15.0208 19.0909 10 19.0909Z"
                            fill="#0C5460"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8817_38163">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>{' '}
                      How can I make a payment using Stripe?
                    </p>
                    <button type="button" onClick={() => setInstructions(true)}>
                      View details
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.attent_flex_contain} table_top attent_flex`}>
              <div className={`${styles.searchcontainer} ${styles.searchcontainer_inner}`}>
                <div className={`${styles.search_contain_box1} ${styles.count_contain} `}>
                  <div className={styles.eventHeaderRow}>
                    <h5>{eventData?.eventName}</h5>
                    {!tableLoading && (eventData?.id || eventData?._id) && (
                      <button
                        type="button"
                        className={styles.viewEventDetailsBtn}
                        onClick={() => navigate(`/show-details/${eventData?.id || eventData?._id}`)}
                        aria-label="View event details"
                      >
                        View Event Details
                      </button>
                    )}
                  </div>
                  {!tableLoading &&
                    eventData?.eventType !== 'rsvp' &&
                    eventData?.eventType !== 'token' && (
                      <div className={styles.tabbtn}>
                        {/* <div className={styles.totalamt1}>
                        <ul>
                          <li>
                            Total Participants: <span>{stats?.totalPeople}</span>
                          </li>
                          <li>
                            Total Adults: <span>{stats?.totalAdults}</span>
                          </li>
                          <li>
                            Total Kids: <span>{stats?.totalKids}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.totalamt}>
                        Total Amount: <span>${stats?.totalAmountPaid}</span>
                      </div>{' '} */}
                        <div className={styles.count_box_contain}>
                          {/* ── People / Ticket stats — change by event type ── */}
                          {eventData?.eventType === 'booking' ? (
                            <ul>
                              <li>
                                <div className={styles.count_text}>Tickets Booked</div>
                                <div className={styles.count_num}>{stats?.totalBookings ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Total Participants</div>
                                <div className={styles.count_num}>{stats?.totalPeople ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Seats Available</div>
                                <div className={styles.count_num}>
                                  {stats?.totalSeatsAvailable ?? 0}/
                                  {stats?.totalNumberOfTickets ?? 0}
                                </div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Check-ins</div>
                                <div className={styles.count_num}>
                                  {stats?.verifiedTickets ?? 0}/{stats?.totalBookings ?? 0}
                                </div>
                              </li>
                            </ul>
                          ) : eventData?.eventType === 'non-seat-booking' ? (
                            <ul>
                              <li>
                                <div className={styles.count_text}>Tickets Booked</div>
                                <div className={styles.count_num}>{stats?.totalBookings ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Total Participants</div>
                                <div className={styles.count_num}>{stats?.totalPeople ?? 0}</div>
                              </li>
                              {(stats?.totalAdults ?? 0) > 0 && (
                                <li>
                                  <div className={styles.count_text}>Adults</div>
                                  <div className={styles.count_num}>{stats?.totalAdults ?? 0}</div>
                                </li>
                              )}
                              {(stats?.totalKids ?? 0) > 0 && (
                                <li>
                                  <div className={styles.count_text}>Kids</div>
                                  <div className={styles.count_num}>{stats?.totalKids ?? 0}</div>
                                </li>
                              )}
                              <li>
                                <div className={styles.count_text}>Check-ins</div>
                                <div className={styles.count_num}>
                                  {stats?.verifiedTickets ?? 0}/{stats?.totalBookings ?? 0}
                                </div>
                              </li>
                            </ul>
                          ) : eventData?.eventType === 'rsvp' ? (
                            <ul>
                              <li>
                                <div className={styles.count_text}>Total RSVPs</div>
                                <div className={styles.count_num}>{stats?.totalBookings ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Total Adults</div>
                                <div className={styles.count_num}>{stats?.totalAdults ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Total Kids</div>
                                <div className={styles.count_num}>{stats?.totalKids ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Check-ins</div>
                                <div className={styles.count_num}>
                                  {stats?.verifiedTickets ?? 0}/{stats?.totalBookings ?? 0}
                                </div>
                              </li>
                            </ul>
                          ) : eventData?.eventType === 'registration' ? (
                            <ul>
                              <li>
                                <div className={styles.count_text}>Total Registrations</div>
                                <div className={styles.count_num}>{stats?.totalBookings ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Total Adults</div>
                                <div className={styles.count_num}>{stats?.totalAdults ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Total Kids</div>
                                <div className={styles.count_num}>{stats?.totalKids ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Check-ins</div>
                                <div className={styles.count_num}>
                                  {stats?.verifiedTickets ?? 0}/{stats?.totalBookings ?? 0}
                                </div>
                              </li>
                            </ul>
                          ) : eventData?.eventType === 'form' ? (
                            /* form (registration): submissions, registrations left, check-ins */
                            <ul>
                              <li>
                                <div className={styles.count_text}>Total Submissions</div>
                                <div className={styles.count_num}>{stats?.totalBookings ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Registrations Left</div>
                                <div className={styles.count_num}>
                                  {stats?.totalSeatsAvailable ?? 0}/
                                  {stats?.totalNumberOfTickets ?? 0}
                                </div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Check-ins</div>
                                <div className={styles.count_num}>
                                  {stats?.verifiedTickets ?? 0}/{stats?.totalBookings ?? 0}
                                </div>
                              </li>
                            </ul>
                          ) : (
                            /* any future types */
                            <ul>
                              <li>
                                <div className={styles.count_text}>Total Participants</div>
                                <div className={styles.count_num}>{stats?.totalPeople ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Tickets Booked</div>
                                <div className={styles.count_num}>{stats?.totalBookings ?? 0}</div>
                              </li>
                              <li>
                                <div className={styles.count_text}>Check-ins</div>
                                <div className={styles.count_num}>
                                  {stats?.verifiedTickets ?? 0}/{stats?.totalBookings ?? 0}
                                </div>
                              </li>
                            </ul>
                          )}

                          {/* ── Financial stats ── */}
                          <ul>
                            <li>
                              <div className={styles.count_text}>Online Payments</div>
                              <div className={styles.count_num}>
                                ${(stats?.totalOnline ?? 0).toFixed(2)}
                              </div>
                            </li>
                            <li>
                              <div className={styles.count_text}>Platform Fees</div>
                              <div className={styles.count_num}>
                                ${(stats?.totalConvinienceFee ?? 0).toFixed(2)}
                              </div>
                            </li>
                            {(stats?.totalDonation ?? 0) > 0 && (
                              <li>
                                <div className={styles.count_text}>Total Donations</div>
                                <div className={styles.count_num}>
                                  ${(stats?.totalDonation ?? 0).toFixed(2)}
                                </div>
                              </li>
                            )}
                            {(stats?.totalDonationConvFee ?? 0) > 0 && (
                              <li>
                                <div className={styles.count_text}>Donation Conv. Fee</div>
                                <div className={styles.count_num}>
                                  ${(stats?.totalDonationConvFee ?? 0).toFixed(2)}
                                </div>
                              </li>
                            )}
                            <li>
                              <div className={styles.count_text}>Payout to Organizer</div>
                              <div className={styles.count_num}>
                                ${(stats?.payOut ?? 0).toFixed(2)}
                              </div>
                            </li>
                            <li>
                              <div className={styles.count_text}>Cash Collected</div>
                              <div className={styles.count_num}>
                                ${(stats?.totalCash ?? 0).toFixed(2)}
                              </div>
                            </li>
                            <li
                              style={{
                                flex: '1 1 100%',
                                borderTop: '1px solid #e5e7eb',
                                paddingTop: '10px',
                                marginTop: '4px',
                              }}
                            >
                              <div className={styles.count_text}>Total Revenue</div>
                              <div className={styles.count_num}>
                                ${(stats?.totalAmountPaid ?? 0).toFixed(2)}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                </div>
                {eventData?.eventType !== 'rsvp' && (
                  <div className={styles.search_contain_box}>
                    <div>
                      <div className={`${styles.search_contain} search_contain`}>
                        <Image src={searchImg} alt="search" />
                        <input
                          className={`${styles[searchboxStyle]} searchbar`}
                          type="search"
                          onChange={onFilterTextChange}
                          placeholder="Search by Name"
                          // value={search}
                        />
                      </div>
                    </div>
                    <div className={styles.tabbtn}>
                      {!tableLoading &&
                        eventData?.status !== 'ended' &&
                        eventData?.status !== 'cancelled' &&
                        eventData?.eventType !== 'token' && (
                          <button
                            className="addBtnyellow pay_btn"
                            onClick={() => {
                              reset({
                                publishablekey: eventData?.stripePublicKey ?? '',
                                secretKey: eventData?.stripeSecretKey ?? '',
                                webhookSecretKey: eventData?.stripeWebhookKey ?? '',
                                convinienceFee: eventData?.convinienceFee ?? '',
                                extraFee: eventData?.extraFee ?? '',
                                feeType: eventData?.convinienceFeeType ?? '',
                                feeFor: eventData?.convinienceFeeFor ?? '',
                                cashBookingPercentage:
                                  eventData?.cashBookingPercentage != null
                                    ? String(eventData.cashBookingPercentage)
                                    : '',
                              });
                              setPaymentShow(true);
                            }}
                          >
                            <svg
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.7142 7.78571C16.5427 7.18571 16.1999 6.58571 15.5999 6.24285L7.54274 1.27142C6.34274 0.499996 4.79988 0.928568 4.02845 2.12857L0.942735 7.27142C0.171307 8.47142 0.599878 10.0143 1.79988 10.7857L2.91416 11.4714V15.5C2.91416 16.8714 4.02845 18.0714 5.48559 18.0714H14.8284C16.1999 18.0714 17.3999 16.9571 17.3999 15.5V9.5C17.3999 8.81428 17.1427 8.21428 16.7142 7.78571ZM14.9142 8.72857C15.3427 8.72857 15.7713 9.07143 15.7713 9.58571V13.0143H4.62845V9.58571C4.62845 9.15714 4.97131 8.72857 5.48559 8.72857H14.9142ZM2.39988 8.12857L5.48559 3.07142C5.74274 2.64285 6.25702 2.55714 6.68559 2.81428L13.5427 7.01428H5.48559C4.11416 7.01428 2.99988 8.12857 2.91416 9.5L2.65702 9.32857C2.31416 9.07142 2.14274 8.55714 2.39988 8.12857ZM14.9142 16.3571H5.48559C5.05702 16.3571 4.62845 16.0143 4.62845 15.5V14.6429H15.6856V15.5C15.7713 16.0143 15.3427 16.3571 14.9142 16.3571Z"
                                fill="white"
                              />
                              <path
                                d="M12.3425 11.2143H14.0568C14.5711 11.2143 14.9139 10.8714 14.9139 10.3571C14.9139 9.84286 14.5711 9.5 14.0568 9.5H12.3425C11.8282 9.5 11.4854 9.84286 11.4854 10.3571C11.4854 10.8714 11.8282 11.2143 12.3425 11.2143Z"
                                fill="white"
                              />
                            </svg>
                            Payment Settings
                          </button>
                        )}
                      {!tableLoading &&
                        eventData?.status !== 'ended' &&
                        eventData?.status !== 'cancelled' &&
                        eventData?.eventType !== 'token' &&
                        !eventData?.qrEnabled && (
                          <button className="addBtn" type="button" onClick={handleModal}>
                            {' '}
                            <FontAwesomeIcon icon={faQrcode} className="add_icon" />
                            Enable QR Scanner
                          </button>
                        )}
                      {!tableLoading && eventData?.status === 'created' && eventData?.qrEnabled && (
                        <button className="addDltBtn" type="button" onClick={handleModal}>
                          {' '}
                          <FontAwesomeIcon icon={faQrcode} className="add_icon" />
                          Disable QR Scanner
                        </button>
                      )}
                      {!tableLoading && canPauseBooking && (
                        <button
                          className="addDltBtn"
                          type="button"
                          disabled={bookingToggleLoading}
                          onClick={() => handleToggleBookingPause('pause')}
                        >
                          {bookingToggleLoading ? 'Please Wait...' : 'Pause Booking'}
                        </button>
                      )}
                      {!tableLoading && canResumeBooking && (
                        <button
                          className="addBtn"
                          type="button"
                          disabled={bookingToggleLoading}
                          onClick={() => handleToggleBookingPause('resume')}
                        >
                          {bookingToggleLoading ? 'Please Wait...' : 'Resume Booking'}
                        </button>
                      )}
                      {!tableLoading &&
                        (eventData?.status === 'created' ||
                          eventData?.status === 'in progress') && (
                          <button
                            className="addDltBtn"
                            type="button"
                            onClick={() => setCancelEventModal(true)}
                            title="Cancel Event"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              style={{ marginRight: '6px' }}
                            >
                              <circle cx="12" cy="12" r="10" />
                              <line x1="15" y1="9" x2="9" y2="15" />
                              <line x1="9" y1="9" x2="15" y2="15" />
                            </svg>
                            Cancel Event
                          </button>
                        )}
                      {!tableLoading && (
                        <button
                          className={`${styles.export_btn} addBtnyellow`}
                          disabled={reportLoading}
                          onClick={() => exportStats(eventData?.id)}
                          title="Download Report"
                        >
                          <svg
                            width="17"
                            height="19"
                            viewBox="0 0 17 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.0773 4.26282L12.3999 0.651062C12.3013 0.554245 12.1686 0.5 12.0303 0.5H2.73328C1.64838 0.5 0.765625 1.38261 0.765625 2.46765V16.5323C0.765625 17.6172 1.64824 18.5 2.73328 18.5H14.2674C15.3523 18.5 16.2351 17.6174 16.2351 16.5323V4.6391C16.2351 4.49751 16.1782 4.36197 16.0773 4.26282ZM12.5577 2.28445L14.4182 4.11176H12.7253C12.6329 4.11176 12.5577 4.0365 12.5577 3.94408V2.28445ZM14.2674 17.4453H2.73328C2.22997 17.4453 1.82031 17.0358 1.82031 16.5323V2.46765C1.82031 1.9642 2.22983 1.55469 2.73328 1.55469H11.5031V3.94408C11.5031 4.61809 12.0515 5.16644 12.7255 5.16644H15.1804V16.5323C15.1804 17.0358 14.7709 17.4453 14.2674 17.4453Z" />
                            <path d="M12.1613 8.86719H4.72742C4.43614 8.86719 4.20007 9.10326 4.20007 9.39453C4.20007 9.68581 4.43614 9.92188 4.72742 9.92188H12.1613C12.4526 9.92188 12.6887 9.68581 12.6887 9.39453C12.6887 9.10326 12.4526 8.86719 12.1613 8.86719Z" />
                            <path d="M4.72742 12.0312H10.7888C11.0801 12.0312 11.3162 11.7952 11.3162 11.5039C11.3162 11.2126 11.0801 10.9766 10.7888 10.9766H4.72742C4.43614 10.9766 4.20007 11.2126 4.20007 11.5039C4.20007 11.7952 4.43614 12.0312 4.72742 12.0312Z" />
                            <path d="M11.5201 13.0859H4.72742C4.43614 13.0859 4.20007 13.322 4.20007 13.6133C4.20007 13.9046 4.43614 14.1406 4.72742 14.1406H11.5201C11.8113 14.1406 12.0475 13.9046 12.0475 13.6133C12.0475 13.322 11.8113 13.0859 11.5201 13.0859Z" />
                          </svg>
                          {reportLoading ? 'Please Wait...' : 'Download'}
                        </button>
                      )}
                      {!tableLoading && (
                        <button
                          className={`${styles.export_btn} addBtnyellow`}
                          disabled={failedReportLoading}
                          onClick={() => exportLogs(eventData?.id)}
                          title="Download Log"
                        >
                          <svg
                            width="17"
                            height="19"
                            viewBox="0 0 17 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.0773 4.26282L12.3999 0.651062C12.3013 0.554245 12.1686 0.5 12.0303 0.5H2.73328C1.64838 0.5 0.765625 1.38261 0.765625 2.46765V16.5323C0.765625 17.6172 1.64824 18.5 2.73328 18.5H14.2674C15.3523 18.5 16.2351 17.6174 16.2351 16.5323V4.6391C16.2351 4.49751 16.1782 4.36197 16.0773 4.26282ZM12.5577 2.28445L14.4182 4.11176H12.7253C12.6329 4.11176 12.5577 4.0365 12.5577 3.94408V2.28445ZM14.2674 17.4453H2.73328C2.22997 17.4453 1.82031 17.0358 1.82031 16.5323V2.46765C1.82031 1.9642 2.22983 1.55469 2.73328 1.55469H11.5031V3.94408C11.5031 4.61809 12.0515 5.16644 12.7255 5.16644H15.1804V16.5323C15.1804 17.0358 14.7709 17.4453 14.2674 17.4453Z" />
                            <path d="M12.1613 8.86719H4.72742C4.43614 8.86719 4.20007 9.10326 4.20007 9.39453C4.20007 9.68581 4.43614 9.92188 4.72742 9.92188H12.1613C12.4526 9.92188 12.6887 9.68581 12.6887 9.39453C12.6887 9.10326 12.4526 8.86719 12.1613 8.86719Z" />
                            <path d="M4.72742 12.0312H10.7888C11.0801 12.0312 11.3162 11.7952 11.3162 11.5039C11.3162 11.2126 11.0801 10.9766 10.7888 10.9766H4.72742C4.43614 10.9766 4.20007 11.2126 4.20007 11.5039C4.20007 11.7952 4.43614 12.0312 4.72742 12.0312Z" />
                            <path d="M11.5201 13.0859H4.72742C4.43614 13.0859 4.20007 13.322 4.20007 13.6133C4.20007 13.9046 4.43614 14.1406 4.72742 14.1406H11.5201C11.8113 14.1406 12.0475 13.9046 12.0475 13.6133C12.0475 13.322 11.8113 13.0859 11.5201 13.0859Z" />
                          </svg>
                          {failedReportLoading ? 'Please Wait...' : 'Download Log'}
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* ── RSVP: Schedule View ── */}
            {eventData?.eventType === 'rsvp' &&
              (() => {
                const SESSION_COLORS = ['#E9D5FF', '#DBEAFE', '#D1FAE5', '#FEF3C7', '#FCE7F3'];
                const parseToMins = (t) => {
                  if (!t || typeof t !== 'string') return 0;
                  const [h, m] = t.trim().split(':');
                  return (parseInt(h, 10) || 0) * 60 + (parseInt(m, 10) || 0);
                };
                const fmtDuration = (mins) => {
                  if (mins <= 0) return '0m';
                  const h = Math.floor(mins / 60);
                  const m = mins % 60;
                  if (h === 0) return `${m}m`;
                  if (m === 0) return `${h}h`;
                  return `${h}h ${m}m`;
                };
                const days = Array.isArray(eventData.scheduleDays) ? eventData.scheduleDays : [];
                const activeDay = days[selectedDay] ?? days[0];
                const sessions = Array.isArray(activeDay?.sessions) ? activeDay.sessions : [];

                // compute total time & conflict for active day
                let totalMins = 0;
                let hasConflict = false;
                const blocks = [];
                sessions.forEach((s) => {
                  const start = parseToMins(s.startTime);
                  const end = parseToMins(s.endTime);
                  if (end > start) {
                    totalMins += end - start;
                    blocks.push({ start, end });
                  }
                });
                blocks.sort((a, b) => a.start - b.start);
                for (let i = 1; i < blocks.length; i += 1) {
                  if (blocks[i].start < blocks[i - 1].end) {
                    hasConflict = true;
                    break;
                  }
                }

                return (
                  <div style={{ padding: '4px 0 24px', maxWidth: '820px' }}>
                    {/* Day tabs */}
                    {days.length > 0 && (
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          marginBottom: '20px',
                          flexWrap: 'wrap',
                        }}
                        role="tablist"
                      >
                        {days.map((day, idx) => (
                          <button
                            type="button"
                            role="tab"
                            key={day._id ?? idx}
                            aria-selected={selectedDay === idx}
                            onClick={() => setSelectedDay(idx)}
                            style={{
                              padding: '7px 18px',
                              borderRadius: '8px',
                              border:
                                selectedDay === idx ? '2px solid #132941' : '1.5px solid #dde3ea',
                              background: selectedDay === idx ? '#132941' : '#fff',
                              color: selectedDay === idx ? '#fff' : '#132941',
                              fontWeight: '600',
                              fontSize: '14px',
                              cursor: 'pointer',
                              transition: 'all 0.15s ease',
                            }}
                          >
                            Day {idx + 1}
                            {day.date && (
                              <span
                                style={{
                                  fontWeight: 400,
                                  marginLeft: '6px',
                                  fontSize: '12px',
                                  opacity: 0.8,
                                }}
                              >
                                {new Date(day.date).toLocaleDateString('en-US', {
                                  month: 'short',
                                  day: 'numeric',
                                })}
                              </span>
                            )}
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Day heading */}
                    {activeDay?.date && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          marginBottom: '18px',
                        }}
                      >
                        <span
                          style={{
                            background: '#132941',
                            color: '#fff',
                            borderRadius: '6px',
                            padding: '4px 14px',
                            fontSize: '13px',
                            fontWeight: '600',
                          }}
                        >
                          Day {selectedDay + 1}
                        </span>
                        <span style={{ fontSize: '15px', fontWeight: '500', color: '#132941' }}>
                          {new Date(activeDay.date).toLocaleDateString('en-US', {
                            weekday: 'long',
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                          })}
                        </span>
                      </div>
                    )}

                    {!activeDay ? (
                      <div
                        style={{
                          textAlign: 'center',
                          padding: '48px',
                          color: '#888',
                          background: '#f8fafc',
                          borderRadius: '12px',
                          border: '1.5px dashed #dde3ea',
                        }}
                      >
                        No schedule available.
                      </div>
                    ) : sessions.length === 0 ? (
                      <div
                        style={{
                          textAlign: 'center',
                          padding: '40px',
                          color: '#aaa',
                          background: '#f8fafc',
                          borderRadius: '12px',
                          border: '1.5px dashed #dde3ea',
                        }}
                      >
                        No sessions for this day.
                      </div>
                    ) : (
                      <>
                        {/* Timeline */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                          {sessions.map((session, sIdx) => {
                            const barColor = SESSION_COLORS[sIdx % SESSION_COLORS.length];
                            const durMins =
                              parseToMins(session.endTime) - parseToMins(session.startTime);
                            const speakerText = Array.isArray(session.speaker)
                              ? session.speaker.join(', ')
                              : session.speaker || '';
                            const locationSpeaker = [session.location, speakerText]
                              .filter(Boolean)
                              .join(' • ');
                            return (
                              <div
                                key={session._id ?? sIdx}
                                style={{
                                  display: 'flex',
                                  alignItems: 'stretch',
                                  gap: '0',
                                  marginBottom: '10px',
                                }}
                              >
                                {/* time column */}
                                <div
                                  style={{
                                    width: '72px',
                                    flexShrink: 0,
                                    paddingTop: '14px',
                                    textAlign: 'right',
                                    paddingRight: '12px',
                                    fontSize: '12px',
                                    color: '#8a99aa',
                                    fontWeight: '500',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {session.startTime
                                    ? (() => {
                                        const [hh, mm] = session.startTime.split(':');
                                        const h = parseInt(hh, 10);
                                        const ampm = h >= 12 ? 'PM' : 'AM';
                                        const h12 = h % 12 || 12;
                                        return `${h12}:${mm} ${ampm}`;
                                      })()
                                    : '—'}
                                </div>
                                {/* color bar */}
                                <div
                                  style={{
                                    width: '4px',
                                    borderRadius: '4px',
                                    background: barColor,
                                    flexShrink: 0,
                                    marginTop: '10px',
                                    marginBottom: '2px',
                                  }}
                                />
                                {/* content block */}
                                <div
                                  style={{
                                    flex: 1,
                                    marginLeft: '12px',
                                    background: '#f8fafc',
                                    border: '1.5px solid #e8edf2',
                                    borderRadius: '10px',
                                    padding: '14px 16px',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'flex-start',
                                      flexWrap: 'wrap',
                                      gap: '6px',
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: '600',
                                        color: '#132941',
                                        fontSize: '14px',
                                      }}
                                    >
                                      {session.title || `Session ${sIdx + 1}`}
                                    </span>
                                    {(session.startTime || session.endTime) && (
                                      <span
                                        style={{
                                          fontSize: '12px',
                                          background: '#e8f4fd',
                                          color: '#1a6ea8',
                                          borderRadius: '20px',
                                          padding: '2px 10px',
                                          fontWeight: '500',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {session.startTime}
                                        {session.endTime ? ` – ${session.endTime}` : ''}
                                      </span>
                                    )}
                                  </div>
                                  {locationSpeaker && (
                                    <p
                                      style={{ margin: '4px 0 0', fontSize: '12px', color: '#667' }}
                                    >
                                      {locationSpeaker}
                                    </p>
                                  )}
                                  <div
                                    style={{
                                      marginTop: '6px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px',
                                      flexWrap: 'wrap',
                                    }}
                                  >
                                    {durMins > 0 && (
                                      <span
                                        style={{
                                          fontSize: '12px',
                                          color: '#8a99aa',
                                          fontWeight: '500',
                                        }}
                                      >
                                        {fmtDuration(durMins)}
                                      </span>
                                    )}
                                    {session.streamingLink && (
                                      <a
                                        href={session.streamingLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          fontSize: '12px',
                                          color: '#1a6ea8',
                                          textDecoration: 'none',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '4px',
                                        }}
                                      >
                                        <svg
                                          width="12"
                                          height="12"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          aria-hidden="true"
                                        >
                                          <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
                                          <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
                                          <line x1="6" y1="1" x2="6" y2="4" />
                                          <line x1="10" y1="1" x2="10" y2="4" />
                                          <line x1="14" y1="1" x2="14" y2="4" />
                                        </svg>
                                        Streaming
                                      </a>
                                    )}
                                  </div>
                                  {session.description && (
                                    <p
                                      style={{
                                        margin: '6px 0 0',
                                        fontSize: '12px',
                                        color: '#666',
                                        lineHeight: '1.5',
                                      }}
                                    >
                                      {session.description}
                                    </p>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {/* Summary row */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            marginTop: '12px',
                            padding: '10px 16px',
                            background: '#f0f4f8',
                            borderRadius: '8px',
                          }}
                        >
                          <span style={{ fontSize: '13px', color: '#132941', fontWeight: '600' }}>
                            {sessions.length} Session{sessions.length !== 1 ? 's' : ''}
                          </span>
                          <span style={{ fontSize: '13px', color: '#667' }}>
                            {fmtDuration(totalMins)} total
                          </span>
                          <span
                            style={{
                              fontSize: '12px',
                              color: hasConflict ? '#c0392b' : '#27ae60',
                              fontWeight: '500',
                              marginLeft: 'auto',
                            }}
                          >
                            {hasConflict ? '⚠ Scheduling conflict' : '✓ No conflicts'}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                );
              })()}

            {/* ── Token: Attendees Joined View ── */}
            {eventData?.eventType === 'token' && (
              <div className="table-responsive" style={{ minHeight: '250px' }}>
                <table className={`${styles.table_attendee} table table-borderless`}>
                  <thead>
                    <tr className={styles[tableheadStyle]}>
                      <th scope="col">User Name</th>
                      <th scope="col">Date Joined</th>
                      <th scope="col">Tokens</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  {!tableLoading ? (
                    <tbody>
                      {tableData.length > 0 ? (
                        tableData.map((item, index) => {
                          const joinedDate = item.ticketId?.bookedDate || item.createdAt;
                          const tokensDisplay =
                            item.tokensLeft != null && item.tokensLeft !== ''
                              ? item.tokensLeft
                              : '\u2014';
                          return (
                            <tr key={item.id ?? index}>
                              <td>{item.userName || item.ticketId?.userName || '\u2014'}</td>
                              <td>
                                {joinedDate
                                  ? DateFormatter(joinedDate, 'toLocaleDateString')
                                  : '\u2014'}
                              </td>
                              <td>{tokensDisplay}</td>
                              <td>
                                {item.paymentStatus === 'booked' ? (
                                  <span
                                    className={`${styles.ststus_text} ${styles.ststus_verified}`}
                                  >
                                    Joined
                                  </span>
                                ) : item.paymentStatus === 'cancelled' ? (
                                  <span
                                    className={`${styles.ststus_text} ${styles.ststus_cancelled}`}
                                  >
                                    Cancelled
                                  </span>
                                ) : item.paymentStatus === 'ticket-pending' ? (
                                  <span
                                    className={`${styles.ststus_text} ${styles.ststus_pending}`}
                                  >
                                    Pending
                                  </span>
                                ) : item.paymentStatus === 'waitlisted' ? (
                                  <span
                                    className={`${styles.ststus_text} ${styles.ststus_waitlisted}`}
                                  >
                                    Waitlisted
                                  </span>
                                ) : (
                                  <span
                                    className={`${styles.ststus_text} ${styles.ststus_not_verified}`}
                                  >
                                    {CapitalizeFirstLetter(item.paymentStatus || 'Pending')}
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="4">
                            <div style={{ textAlign: 'center', padding: '30px' }}>
                              <Image src={noresults} alt="" />
                              <h6 className={styles.norecord}>No Items to Display</h6>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="4">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: '50px 0',
                            }}
                          >
                            <p style={{ margin: 0, color: '#888' }}>Loading...</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            )}

            {/* ── Default: Standard Attendees Table (form, booking, non-seat-booking, registration, etc.) ── */}
            {eventData?.eventType !== 'rsvp' && eventData?.eventType !== 'token' && (
              <div className="table-responsive" style={{ minHeight: '250px' }}>
                <table className={`${styles.table_attendee} table table-borderless`}>
                  <thead>
                    <tr className={styles[tableheadStyle]}>
                      {eventData?.eventType !== 'form' && <th scope="col">Registered Users</th>}
                      {eventData?.eventType === 'form' && <th scope="col">Attendees</th>}
                      <th scope="col">Net Amount</th>
                      {eventData?.isCoupon && <th scope="col">Coupon Discount</th>}
                      <th scope="col">Paid Amount</th>
                      <th scope="col">Payment Mode</th>
                      {eventData?.eventType === 'booking' && <th scope="col">Seats</th>}
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  {Object.keys(tableData) && !tableLoading ? (
                    <tbody>
                      {tableData.map((item, index) => (
                        <tr key={getRowTicketId(item) || item?.id || index}>
                          {eventData?.eventType !== 'form' && <td>{item.userName}</td>}
                          {eventData?.eventType === 'form' && <td>{item?.userName}</td>}
                          <td>
                            $
                            {item.ticketId.totalPrice && item?.ticketId?.totalPrice > 0
                              ? item?.ticketId?.totalPrice?.toFixed(2)
                              : '0.00'}
                          </td>
                          {eventData?.isCoupon && (
                            <td>
                              $
                              {item.ticketId.couponDiscount
                                ? item?.ticketId?.couponDiscount?.toFixed(2)
                                : '0.00'}
                            </td>
                          )}
                          <td>
                            $
                            {item.ticketId.totalAmount
                              ? item.ticketId.totalAmount?.toFixed(2)
                              : '0.00'}
                          </td>
                          <td>{CapitalizeFirstLetter(item.ticketId.paymentMethod)}</td>
                          {eventData?.eventType === 'booking' && <td>{item.seatsBooked}</td>}
                          {item.paymentStatus === 'cancelled' ? (
                            <td>
                              <span>
                                <svg
                                  width="20"
                                  height="20"
                                  clipRule="evenodd"
                                  fillRule="evenodd"
                                  imageRendering="optimizeQuality"
                                  shapeRendering="geometricPrecision"
                                  textRendering="geometricPrecision"
                                  viewBox="0 0 21.0001 21.0001"
                                  xmlns="http://www.w3.org/2000/svg"
                                  id="fi_14090261"
                                >
                                  <g id="图层_x0020_1">
                                    <path d="m0 0h21v21h-21z" fill="none" />
                                    <path
                                      d="m10.5 1.3124c5.07328 0 9.1876 4.11432 9.1876 9.1876s-4.11432 9.1876-9.1876 9.1876-9.1876-4.11432-9.1876-9.1876 4.11432-9.1876 9.1876-9.1876zm-3.93814 8.2033h7.87628c.54211 0 .9843.4422.9843.9843 0 .54211-.44367.9843-.9843.9843h-7.87628c-.54063 0-.9843-.4422-.9843-.9843 0-.54211.4422-.9843.9843-.9843z"
                                      fill="#FF0000"
                                    />
                                  </g>
                                </svg>
                                <span
                                  className={`${styles.ststus_text} ${styles.ststus_cancelled}`}
                                >
                                  Cancelled
                                </span>
                                {/* <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="12" cy="12" r="12" fill="#FF0000" />
                                <rect
                                  x="6.69922"
                                  y="5"
                                  width="16.9375"
                                  height="2.79"
                                  rx="1.395"
                                  transform="rotate(46.478 6.69922 5)"
                                  fill="white"
                                />
                                <rect
                                  x="5"
                                  y="17.1092"
                                  width="16.9375"
                                  height="2.78807"
                                  rx="1.39404"
                                  transform="rotate(-45 5 17.1092)"
                                  fill="white"
                                />
                              </svg> */}
                              </span>
                            </td>
                          ) : item.paymentStatus === 'ticket-pending' ? (
                            <td>
                              <span
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  width: 'max-content',
                                  alignItems: 'center',
                                  gap: '6px',
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true"
                                >
                                  <circle cx="12" cy="12" r="12" fill="#F59E0B" />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12 6.5V12L15.5 14.5"
                                    stroke="white"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    fill="none"
                                  />
                                </svg>
                                <span className={`${styles.ststus_text} ${styles.ststus_pending}`}>
                                  Pending
                                </span>
                              </span>
                            </td>
                          ) : item.paymentStatus === 'waitlisted' ? (
                            <td>
                              <span
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  width: 'max-content',
                                  alignItems: 'center',
                                  gap: '6px',
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true"
                                >
                                  <circle cx="12" cy="12" r="12" fill="#7C3AED" />
                                  <path
                                    d="M8 10h8M8 14h5"
                                    stroke="white"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                  />
                                </svg>
                                <span
                                  className={`${styles.ststus_text} ${styles.ststus_waitlisted}`}
                                >
                                  Waitlisted
                                </span>
                              </span>
                            </td>
                          ) : !item.isVerified ? (
                            <td>
                              <span>
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_7688_26940)">
                                    <path
                                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                      fill="#C9C7C5"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M8.25143 17.8528L3.86264 13.1555C3.26179 12.5124 3.29628 11.4949 3.93936 10.8941C4.58245 10.2932 5.5999 10.3278 6.20075 10.9708L9.58607 14.594L14.9446 9.5874C14.9928 9.54233 15.0431 9.50104 15.0952 9.46305L17.6151 7.10869C18.2582 6.50784 19.2757 6.54242 19.8765 7.18551C20.4773 7.8285 20.4428 8.84604 19.7998 9.44689L12.1033 16.6379L12.0951 16.6291L9.43281 19.1166L8.25143 17.8528Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_7688_26940">
                                      <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <span
                                  className={`${styles.ststus_text} ${styles.ststus_not_verified}`}
                                >
                                  Not Verified
                                </span>
                              </span>
                            </td>
                          ) : (
                            <td>
                              <span>
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_7688_26945)">
                                    <path
                                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                      fill="#00BA00"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M8.25143 17.8528L3.86264 13.1555C3.26179 12.5124 3.29628 11.4949 3.93936 10.8941C4.58245 10.2932 5.5999 10.3278 6.20075 10.9708L9.58607 14.594L14.9446 9.5874C14.9928 9.54233 15.0431 9.50104 15.0952 9.46305L17.6151 7.10869C18.2582 6.50784 19.2757 6.54242 19.8765 7.18551C20.4773 7.8285 20.4428 8.84604 19.7998 9.44689L12.1033 16.6379L12.0951 16.6291L9.43281 19.1166L8.25143 17.8528Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_7688_26945">
                                      <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <span className={`${styles.ststus_text} ${styles.ststus_verified}`}>
                                  Verified
                                </span>
                              </span>
                            </td>
                          )}
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                              <span className={`${styles.refund}`}>
                                <OverlayTrigger
                                  overlay={<Tooltip id="tooltip-disabled">View</Tooltip>}
                                >
                                  <Button
                                    className={styles.refund_tooltip}
                                    onClick={(e) => actionView(e, item)}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M19.8729 9.61099C19.6942 9.36658 15.4371 3.62637 9.9999 3.62637C4.56274 3.62637 0.305391 9.36658 0.126914 9.61076C-0.0423048 9.84264 -0.0423048 10.1571 0.126914 10.389C0.305391 10.6334 4.56274 16.3736 9.9999 16.3736C15.4371 16.3736 19.6942 10.6334 19.8729 10.3892C20.0423 10.1574 20.0423 9.84264 19.8729 9.61099ZM9.9999 15.055C5.99486 15.055 2.52606 11.2451 1.49922 9.99955C2.52473 8.75295 5.98626 4.94505 9.9999 4.94505C14.0048 4.94505 17.4733 8.75427 18.5006 10.0004C17.4751 11.247 14.0135 15.055 9.9999 15.055Z"
                                        fill="#98999E"
                                      />
                                      <path
                                        d="M10 6.04396C7.81868 6.04396 6.04395 7.81869 6.04395 10C6.04395 12.1814 7.81868 13.9561 10 13.9561C12.1813 13.9561 13.9561 12.1814 13.9561 10C13.9561 7.81869 12.1813 6.04396 10 6.04396ZM10 12.6374C8.54571 12.6374 7.36266 11.4543 7.36266 10C7.36266 8.54576 8.54575 7.36267 10 7.36267C11.4543 7.36267 12.6374 8.54576 12.6374 10C12.6374 11.4543 11.4543 12.6374 10 12.6374Z"
                                        fill="#98999E"
                                      />
                                    </svg>
                                  </Button>
                                </OverlayTrigger>
                              </span>
                              {item?.paymentStatus === 'ticket-pending' && getRowTicketId(item) && (
                                <span
                                  className={styles.rowActionsTicketApproval}
                                  role="group"
                                  aria-label="Registration approval"
                                >
                                  <button
                                    type="button"
                                    className={styles.approveTicketBtn}
                                    aria-label="Approve registration"
                                    title="Approve registration"
                                    disabled={
                                      approvalLoading[getRowTicketId(item)]?.approve ||
                                      approvalLoading[getRowTicketId(item)]?.reject ||
                                      approvePreviewLoading[getRowTicketId(item)]
                                    }
                                    onClick={() =>
                                      handlePrepareApproveConfirm(
                                        getRowTicketId(item),
                                        getRowAttendeeLabel(item)
                                      )
                                    }
                                  >
                                    {approvalLoading[getRowTicketId(item)]?.approve ||
                                    approvePreviewLoading[getRowTicketId(item)] ? (
                                      <span className={styles.ticketApprovalActionSpinner} />
                                    ) : (
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                      >
                                        <path
                                          d="M12.25 3.5L5.25 10.5L1.75 7"
                                          stroke="#166534"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    )}
                                  </button>
                                  <button
                                    type="button"
                                    className={styles.rejectTicketBtn}
                                    aria-label="Reject registration"
                                    title="Reject registration"
                                    disabled={
                                      approvalLoading[getRowTicketId(item)]?.approve ||
                                      approvalLoading[getRowTicketId(item)]?.reject
                                    }
                                    onClick={() =>
                                      handleOpenTicketConfirmModal(
                                        'reject',
                                        getRowTicketId(item),
                                        getRowAttendeeLabel(item)
                                      )
                                    }
                                  >
                                    {approvalLoading[getRowTicketId(item)]?.reject ? (
                                      <span className={styles.ticketApprovalActionSpinner} />
                                    ) : (
                                      <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                      >
                                        <path
                                          d="M1 1L11 11M11 1L1 11"
                                          stroke="#991b1b"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    )}
                                  </button>
                                </span>
                              )}
                              {eventData?.status === 'in progress' &&
                                !item?.isVerified &&
                                item?.paymentStatus === 'booked' && (
                                  <span className={`${styles.refund}`}>
                                    <OverlayTrigger
                                      overlay={<Tooltip id="tooltip-disabled">Verify</Tooltip>}
                                    >
                                      <Button onClick={(e) => handleVerify(e, item)}>
                                        <span>
                                          <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clipPath="url(#clip0_7688_26940)">
                                              <path
                                                d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                                fill="#C9C7C5"
                                              />
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.25143 17.8528L3.86264 13.1555C3.26179 12.5124 3.29628 11.4949 3.93936 10.8941C4.58245 10.2932 5.5999 10.3278 6.20075 10.9708L9.58607 14.594L14.9446 9.5874C14.9928 9.54233 15.0431 9.50104 15.0952 9.46305L17.6151 7.10869C18.2582 6.50784 19.2757 6.54242 19.8765 7.18551C20.4773 7.8285 20.4428 8.84604 19.7998 9.44689L12.1033 16.6379L12.0951 16.6291L9.43281 19.1166L8.25143 17.8528Z"
                                                fill="white"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_7688_26940">
                                                <rect width="24" height="24" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </span>
                                      </Button>
                                    </OverlayTrigger>
                                  </span>
                                )}
                              {eventData?.status !== 'ended' &&
                                !item?.isVerified &&
                                item?.paymentStatus === 'booked' && (
                                  <span className={`${styles.refund}`}>
                                    <OverlayTrigger
                                      overlay={<Tooltip id="tooltip-disabled">Refund</Tooltip>}
                                    >
                                      <Button onClick={(e) => handleDelete(e, item)}>
                                        {/* <span className={styles.tooltiptext}>Tooltip text</span> */}
                                        <svg
                                          id="fi_4947544"
                                          height="26"
                                          viewBox="0 0 512 512"
                                          width="26"
                                          xmlns="http://www.w3.org/2000/svg"
                                          data-name="Layer 1"
                                        >
                                          <path
                                            d="m457.052 230.633a202.662 202.662 0 0 0 -197.686-177.273l13.9-13.787a10.666 10.666 0 1 0 -15.021-15.146l-33.787 33.513a10.663 10.663 0 0 0 -.062 15.083l33.786 34.065a10.666 10.666 0 1 0 15.146-15.021l-17.228-17.374a181.34 181.34 0 0 1 113.2 322.907 10.667 10.667 0 0 0 13.344 16.646c55.481-44.491 83.299-113.131 74.408-183.613z"
                                            fill="#98999E"
                                          />
                                          <path
                                            d="m253.818 404.911a10.666 10.666 0 1 0 -15.146 15.021l17.228 17.368a181.332 181.332 0 0 1 -113.233-322.87 10.668 10.668 0 0 0 -13.354-16.641c-55.454 44.495-83.256 113.122-74.365 183.576a202.645 202.645 0 0 0 197.692 177.267l-13.906 13.795a10.666 10.666 0 1 0 15.021 15.146l33.786-33.516a10.663 10.663 0 0 0 .063-15.083z"
                                            fill="#98999E"
                                          />
                                          <path
                                            d="m264.469 247.565c-1.516-.581-2.937-1.117-4.161-1.656-1.344-.594-2.953-1.211-4.729-1.885-10.1-3.836-15.578-6.867-15.578-11.885 0-2.216 2.365-5.656 6.88-7.943 3.2-1.617 14.75-6.047 29.469 4.771a10.666 10.666 0 1 0 12.635-17.187 57.463 57.463 0 0 0 -22.318-10.123v-9.657a10.667 10.667 0 0 0 -21.333 0v10.159a42.673 42.673 0 0 0 -8.083 3c-11.464 5.8-18.583 16.138-18.583 26.979 0 20.688 19.813 28.214 29.339 31.831 1.38.521 2.641.995 3.688 1.458 1.526.672 3.281 1.349 5.161 2.068 10.474 4 15.146 6.641 15.146 11.7 0 2.214-2.365 5.656-6.88 7.938-3.2 1.615-14.745 6.052-29.469-4.771a10.666 10.666 0 1 0 -12.635 17.188 57.62 57.62 0 0 0 22.318 10.194v10.256a10.667 10.667 0 0 0 21.333 0v-10.785a42.7 42.7 0 0 0 8.083-3.044c11.464-5.8 18.583-16.135 18.583-26.974-.002-20.603-18.778-27.778-27.778-31.632z"
                                            fill="#98999E"
                                          />
                                          <path
                                            d="m256 138.667a117.333 117.333 0 1 0 117.333 117.333 117.466 117.466 0 0 0 -117.333-117.333zm0 213.333a96 96 0 1 1 96-96 96.112 96.112 0 0 1 -96 96z"
                                            fill="#98999E"
                                          />
                                        </svg>
                                      </Button>
                                    </OverlayTrigger>
                                  </span>
                                )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                  {tableData.length === 0 && !tableLoading ? (
                    <tbody>
                      <tr>
                        <td colSpan="7">
                          <div className={styles.norecordsdiv}>
                            <Image src={noresults} alt="" />
                            <h6 className={styles.norecord}>No Items to Display</h6>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : null}
                  {tableLoading && (
                    <tbody>
                      <tr>
                        <td colSpan="7">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: '50px 0',
                            }}
                          >
                            <p style={{ margin: 0, color: '#888' }}>Loading...</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            )}
          </div>
          {!tableLoading && tableData.length !== 0 && eventData?.eventType !== 'rsvp' && (
            <Paginations
              paginationData={paginationData}
              setPageNum={handlePageChange}
              dataName="User"
            />
          )}
        </div>
      )}
    </div>
  );
});

AttendeeCustomTable.propTypes = {
  section: PropTypes.string,
};

AttendeeCustomTable.defaultProps = {
  section: 'User',
};

export default AttendeeCustomTable;
